import {commercialWebsocketCommands} from '../../constants/commercialWebsocketCommands';

export const COMMERCIAL_HISTORY_FETCH = 'COMMERCIAL_HISTORY_FETCH';

export const fetchCommercialHistory = (pageSize, sorted, cursor, isNextFromPivot, filtered) => dispatch => {
    dispatch({
        type: COMMERCIAL_HISTORY_FETCH,
        commercialWebsocket: true,
        command: commercialWebsocketCommands.COMMERCIAL_HISTORY_GET,
        payload: {
            pageSize: pageSize,
            sorted: sorted,
            cursor: cursor,
            isNextFromPivot: isNextFromPivot,
            filtered: filtered
        }
    });
};
